<template>
  <div>
    <breadcrumb :breadcrumb="breadcrumb" />
    <div class="search-line">
      <div class="btn-box">
        <button-add :pathName="addController" v-if="permissionCodes.indexOf('045002001') !== -1" />
      </div>
      <div style="display: flex; justify-content: flex-start">
        <input-select selectTitle="设备状态" :selectKey="'deviceStatus'" selectWidth="100px" :selectData="deviceStatusList" @search="search" style="margin-right: 10px" />
      </div>
      <input-search placeholder="集中器名称" @search="searchKey" />
    </div>
    <table-main :selection="false" :tableHead="tableHead" :tableData="tableData" @toCurrentPage="toCurrentPage" @deleteLine="deleteLine" @changeSelection="changeSelection" :total="total" :pageNum="pageNum" :pageSize="pageSize" @changePagination="changePagination" :operationArr="operationArr" />
  </div>
</template>

<script>
import Breadcrumb from '../../../components/Breadcrumb/Breadcrumb'
import ButtonAdd from '../../../components/Button/ButtonAdd'
import ButtonDelete from '../../../components/Button/ButtonDelete'
import ButtonExport from '../../../components/common/buttons/button-export'
import ButtonUpload from '../../../components/common/buttons/button-upload'
import InputSearch from '../../../components/Input/InputSearch'
import InputSelect from '../../../components/Input/InputSelect'
import TableMain from '../../../components/Table/TableMain'
import { api } from '../../api/SteamManagement'
import { errorHandler } from '../../../utils/errorHandler'
import { nAlert, nSuccess } from '../../../utils/notice'
import { bus } from '../../../utils/bus'

export default {
  components: {
    TableMain,
    InputSelect,
    InputSearch,
    ButtonUpload,
    ButtonExport,
    ButtonDelete,
    ButtonAdd,
    Breadcrumb,
  },
  name: 'steam-controller-management',
  data() {
    return {
      permissionCodes: '',
      breadcrumb: [
        {
          value: '智慧蒸汽',
          name: 'steam-over-view',
        },
        {
          value: '集中器管理',
        },
      ],
      addController: 'steam-controller-add',
      exportUrl: '',
      tableHead: [
        {
          prop: 'name',
          label: '设备名称',
        },
        {
          prop: 'deviceCode',
          label: '设备编号',
        },
        {
          prop: 'deviceStatus',
          isStatus: true,
          label: '设备状态',
        },
      ],
      tableData: [],
      total: 0,
      pageSize: 10,
      pageNum: 1,
      selectionArr: [],
      deviceStatusList: [
        {
          key: '',
          label: '全部',
        },
        {
          key: '1',
          label: '在线',
        },
        {
          key: '0',
          label: '离线',
        },
      ],
      requestData: {
        searchKey: '',
        deviceStatus: '',
      },
      operationArr: ['current', 'delete'],
    }
  },
  created() {
    this.permissionCodes = bus.global.permissionCodes
    this.getPage()
  },
  activated() {
    this.getPage()
  },
  methods: {
    // 获取集中器
    getPage() {
      let reqData = this.requestData
      reqData.pageNum = this.pageNum
      reqData.pageSize = this.pageSize
      this.$axios
        .post(api.getSteamControlDevicePage, reqData)
        .then((res) => {
          let data = res.data.data.list
          data.map((v) => {
            v.code = v.deviceCode
          })
          this.total = res.data.data.total
          this.tableData = data
        })
        .catch(errorHandler('获取信息失败'))
    },
    search(v) {
      this.pageNum = 1
      this.requestData[v.key] = v.value
      this.getPage()
    },
    searchKey(v) {
      this.pageNum = 1
      this.requestData.searchKey = v
      this.getPage()
    },
    changePagination(data) {
      this.pageNum = data[0]
      this.pageSize = data[1]
      this.getPage()
    },
    changeSelection(codeArr) {
      this.selectionArr = codeArr
    },
    toCurrentPage(code) {
      this.$router.push({
        path: `/steam_controller_current/${code}`,
      })
    },
    deleteLine(code) {
      let codes = code.join(',')
      this.$axios
        .post(api.deleteSteamControlDeviceByCodes, {
          codes,
        })
        .then((res) => {
          nSuccess('删除成功')
          this.getPage()
        })
        .catch(errorHandler('删除失败'))
    },
  },
}
</script>

<style scoped>
.search-line {
  display: flex;
  justify-content: space-between;
  margin: 20px 0;
}
.btn-box {
  display: flex;
  justify-content: flex-start;
}
</style>

<style lang="less">
.el-input--small .el-input__inner {
  line-height: 30px;
}
</style>



// WEBPACK FOOTER //
// src/view/SteamManage/ControllerManagement/ControllerManagement.vue